import { render, staticRenderFns } from "./VuesticNavbar.vue?vue&type=template&id=5f12b0c1&"
import script from "./VuesticNavbar.vue?vue&type=script&lang=js&"
export * from "./VuesticNavbar.vue?vue&type=script&lang=js&"
import style0 from "./VuesticNavbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticNavbar.vue"
export default component.exports